// Import react.
import * as React from 'react';
// Import enumerations.
import {
	BreakpointWidth,
} from '@app/enumerations';
// Import hooks.
import { useMediaQuery } from 'react-responsive';

interface UseResponsiveResult{
	isDesktop: boolean;
	windowHeight: number;
	windowWidth: number;
}



const useResponsive = (): UseResponsiveResult => {

	// #region utility methods
	const updateWindowSize = (): void => {
		setWindowSize((currentWindowSize: { windowHeight: number, windowWidth: number }) => {
			return {
				windowHeight: window.innerHeight,
				windowWidth: window.innerWidth,
			};
		});
	}
	// #endregion utility methods.
	
	// #region variables

	const isDesktop: boolean = useMediaQuery({
		minWidth: BreakpointWidth.LARGE
	});

	const [windowSize, setWindowSize] = React.useState<{ windowHeight: number, windowWidth: number }>({
		windowHeight: window.innerHeight,
		windowWidth: window.innerWidth,
	});

	// #endregion variables

	// #region life-cycle methods.
	React.useEffect(() => {
		window.addEventListener("resize", updateWindowSize);
		return () => {
			window.removeEventListener("resize", updateWindowSize);
		}
	}, []);
	// #endregion life-cycle methods.
	return {
		isDesktop: isDesktop,
		windowHeight: windowSize.windowHeight,
		windowWidth: windowSize.windowWidth,
	};
}


// Export results.
export {
	UseResponsiveResult,
}

export default useResponsive;